import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import React from "react";
import quotes from "./quotes.js";
import Modal from "react-modal";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Ad from "./Ad.js";

function App() {
  const [quote, setQuote] = useState("");
  const [image, setImage] = useState("");
  const [selectedFn, setSelectedFn] = useState("reddit");
  const [selectedText, setSelectedText] = useState("quote");
  const [imageList, setImageList] = useState([]);
  const [hideQuote, setHideQuote] = useState(false);
  const [hideImage, setHideImage] = useState(false);
  const [subreddit, setSubreddit] = useState("wallpaper");
  const [keyword, setKeyword] = useState("wallpaper");
  const [isOpen, setIsOpen] = useState(false);
  const handle = useFullScreenHandle();
  const [selectedTags, setTags] = useState([]);
  const [tapCount, setTapCount] = useState(0);
  const [isAdOpen, setIsAdOpen] = useState(false);
  const tags = ["motivation","inspiration","life","wisdom","love","success","leadership","happiness","change","perseverance","mindfulness","growth","courage","gratitude","resilience","friendship","creativity","humility","forgiveness","patience","integrity","self-reflection","empathy","purpose","justice","harmony","knowledge","hope","anger","fear","general"];

  //GET random joke from r/jokes
  const getRandomJoke = async () => {
    const response = await fetch("https://www.reddit.com/r/jokes/random.json");
    const data = await response.json();
    const joke = data[0].data.children[0].data.title + " " + data[0].data.children[0].data.selftext;
    setQuote(joke);
  };

  const getRandomImage = () => {
    fetch("https://source.unsplash.com/random/1920x1080")
      .then((response) => {
        setImage(response.url);
        console.log(response.url);
        return response.url;
      })
  }



  //get random image from subbreddit
  const getRandomImageFromSubreddit = () => {
    let displaywidth = window.innerWidth;
    let displayheight = window.innerHeight;
    console.log(displaywidth, displayheight);
    // picsum photos random image
    const rndInt = Math.floor(Math.random() * 1000) + 1
    setImage('https://picsum.photos/id/' + rndInt + '/' + displaywidth + '/' + displayheight);
    console.log('https://picsum.photos/id/' + rndInt + '/' + displaywidth + '/' + displayheight);

    // fetch("https://www.reddit.com/r/"+subreddit+"/random.json")
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     // console.log('here',data[0].data.children[0].data.preview.images[0].resolutions[0].url);

    //     // setImage(data[0].data.children[0].data.url);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  }

  //get random quote from api
  const getRandomQuote = () => {
    let tagQuery = '';
    if (selectedTags.length > 0) {
      tagQuery = '?tags=' + selectedTags.join(',');
    }
    fetch("https://quoteslate.vercel.app/api/quotes/random"+tagQuery, {
      method: "GET",
    })
      .then(async (response) => {
        const data = await response.json();
        setQuote(data.quote);
        console.log(data.quote);
      }).catch((err) => {
        console.error(err);
      });
  }

  //get color name from hex code
  const getColorName = (hex) => {
    fetch(`https://www.thecolorapi.com/id?hex=${hex}`)
      .then((response) => {
        return response.json();
      }).then((data) => {
        console.log(data.name.value);
      })
  };

  //get image by keyword
  const getImageByKeyword = (keyword) => {
    fetch(`https://source.unsplash.com/1600x900/?${keyword}`)
      .then((response) => {
        setImage(response.url);
        console.log(response.url);
        return response.url;
      })
  }

  //get random fact from api
  const getRandomFact = () => {
    fetch("https://uselessfacts.jsph.pl/random.json?language=en")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.text);
        setQuote(data.text);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //get image list of 1000 images from subreddit
  const getImageListFromSubreddit = () => {
    fetch(`https://www.reddit.com/r/pics/top.json?t=year?limit=None`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setImageList(data.data.children.map((child) => child.data.url));
      })
      .catch((err) => {
        console.error(err);
      });
  }

  useEffect(() => {

    if (selectedFn === 'reddit') {
      getRandomImageFromSubreddit();
    }
    else if (selectedFn === 'unsplash') {
      getImageByKeyword(keyword);
    }
    else if (selectedFn === 'unsplashrandom') {
      getRandomImage();
    }
    if (selectedText === 'quote') {
      getRandomQuote();
    }
    else if (selectedText === 'fact') {
      getRandomFact();
    } else if (selectedText === 'joke') {
      getRandomJoke();
    }
  }, [selectedFn, selectedText, keyword, subreddit]);

  const getData = () => {
    tapCount + 1 >= 5 ? setTapCount(0) : setTapCount(tapCount + 1);
    if (selectedFn === 'reddit') {
      getRandomImageFromSubreddit();
    }
    else if (selectedFn === 'unsplash') {
      getImageByKeyword(keyword);
    }
    else if (selectedFn === 'unsplashrandom') {
      getRandomImage();
    }
    if (selectedText === 'quote') {
      getRandomQuote();
    }
    else if (selectedText === 'fact') {
      getRandomFact();
    } else if (selectedText === 'joke') {
      getRandomJoke();
    }
  }

  const enableHover = (event) => {
    event.style.opacity = 1;
    event.style.backdropFilter = 'blur(7px)';
    event.style.backgroundColor = 'rgba(24, 26, 27, 0.28)';
    event.style.transition = 'opacity 0.5s ease-in-out';
    // remove hover after 3 seconds and enable on mouseover again
    setTimeout(() => {
      event.style.opacity = 0;
    }, 1000);
  }

  const removeHover = (event) => {
    event.style.opacity = 0;
  } 


  const [isMobile, setMobile] = useState(false);

  React.useEffect(() => {
    _isMobileScreen();
    window.addEventListener("resize", _isMobileScreen);
  }, []);

  const _isMobileScreen = () => {
    if (window.innerWidth <= 768) {
      setMobile(true);
      return;
    }
    setMobile(false);
  };

  return <FullScreen handle={handle}>
    <div className="App" style={{ background: '#000' }}>
      {/* image slider populated from imagelist */}
      {/* {imageList.length > 0 && <div className="image-slider">
        <div className="image-slider-container">
          <div className="image-slider-wrapper">
            {imageList.map((image, index) => {
              return (!image.includes('redgif') && !image.includes('gifv')) && <div className="image-slider-item" key={index}>
                <img className="slider-image" src={image} alt=""/>
              </div>
            })}
          </div>
        </div>
      </div>} */}

      {/* <img src={isMobile?"https://picsum.photos/1080/1920/":"https://picsum.photos/1920/1080/"} style={{objectFit:'cover',zIndex:0,top:0,left:0 ,position:'fixed',overflow:'hidden',height:'100%',width:'100vw'}}>
    </img> */}
      {<img src={!hideImage ? image : '/blank.png'} alt="background" style={{ background: '#000', objectFit: 'cover', zIndex: 0, top: 0, left: 0, position: 'fixed', overflow: 'hidden', height: '100%', width: '100vw' }}>
      </img>}
      {isOpen && <Modal style={{zIndex:'5'}} isOpen={isOpen} onClose={() => setIsOpen(false)} shouldCloseOnEsc={true} >
        <div className="modal-content" style={{zIndex:'5'}}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}><p style={{ padding: '0px 0px', fontWeight: 'bold', fontSize: '24px' }}>Options</p><p style={{ padding: '0px 0px' }} onClick={() => { setIsOpen(false) }}>Close</p></div>
          
          <p>Changes will take effect on next quote load.</p>
          <div className="option-container" style={{ display: 'flex', flexDirection: 'column' }}>
            <select value={selectedFn} onChange={(e) => { setSelectedFn(e.target.value) }}>
              <option value="reddit">Reddit</option>
              <option value="unsplash">Unsplash</option>
              <option value="unsplashrandom">Unsplash Random Image</option>
            </select>

            {/* <select value={selectedText} onChange={(e) => { setSelectedText(e.target.value) }}>
              <option value="quote">Quote</option>
              <option value="fact">Fact</option>
              <option value="joke">Joke</option>
            </select> */}

            {selectedFn === 'reddit' && <input className="input-box" type="text" placeholder="subreddit" value={subreddit} onChange={(e) => { setSubreddit(e.target.value) }} />}
            {selectedFn === 'unsplash' && <input className="input-box" type="text" placeholder="keyword" value={keyword} onChange={(e) => { setKeyword(e.target.value) }} />}

            <div className="input-box tag-container" style={{background:'rgba(68, 68, 68, 1)'}}>
              {(selectedTags.length === 0) && <span style={{ color: '#888', marginTop: "0px" }}>Select Your Category</span>}
              {
                selectedTags.map((tag, index) => (
                  <span key={index} className="tag-item" onClick={() => {
                    const newTags = selectedTags.filter(t => t !== tag);
                    setTags(newTags);
                  }}>{tag} &times;</span>
                ))

              }
            </div>
            <div className="tag-container">
              {tags.map((tag, index) => (
                <span key={index} className={`tag-item ${selectedTags.includes(tag) ? 'tag-item-selected' : ''}`} onClick={() => {
                  if (selectedTags.includes(tag)) {
                    const newTags = selectedTags.filter(t => t !== tag);
                    setTags(newTags);
                  } else {
                    setTags([...selectedTags, tag]);
                  }
                }
                }>{tag}</span>
              ))}
            </div>

              <div>Auto Refresh every </div>
              <select id="auto-play-select" onChange={(e) => {
                const val = e.target.value;
                if (val === 'off') {
                  if (window.autoPlayInterval) {
                    clearInterval(window.autoPlayInterval);
                  }
                  return;
                }
                if (window.autoPlayInterval) {
                  clearInterval(window.autoPlayInterval);
                }

                window.autoPlayInterval = setInterval(() => {
                  getData();
                }, parseInt(val) * 1000);
              }}>
                <option value="off">Off</option>
                <option value="5">5 seconds</option>
                <option value="10">10 seconds</option>
                <option value="30">30 seconds</option>
                <option value="60">1 minute</option>
              </select>




            <div className="flex-row"><input type={'checkbox'} checked={hideImage} onChange={() => { setHideImage(!hideImage) }} /> Hide Image</div>
            <div className="flex-row"><input type={'checkbox'} checked={hideQuote} onChange={() => { setHideQuote(!hideQuote) }} /> Hide Text</div>
            {(!document.fullscreenElement) &&
            <button onClick={()=>{
              var el = document.documentElement,
                    rfs = el.requestFullscreen;
                if(typeof rfs!="undefined" && rfs){
                  rfs.call(el);
                }
                setIsOpen(false);
               }} style={{padding:"10px"}}>
              Enter fullscreen
            </button>
}            {(document.fullscreenElement) &&
            <button onClick={()=>{
              if(document.exitFullscreen){
                document.exitFullscreen();
              }
              setIsOpen(false);
            }} style={{padding:"10px"}}>
              Exit fullscreen
            </button>
            }

          </div>
        </div>
      </Modal>
      }
      {
        isAdOpen && <Modal style={{zIndex:'5'}} isOpen={isAdOpen} onClose={() => setIsAdOpen(false)} shouldCloseOnEsc={true} >
          <div className="modal-content" style={{zIndex:'5', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%'}}>
            <Ad dataAdSlot="1621283016" />
            <button style={{padding:'10px 15px 10px 10px',background: '#8a8a8aff' , color:'#fff', fontSize:'18px',position:'absolute',top:20, right: 20, borderRadius: '40px', outline: 'none', border: 'none', display: 'flex', gap: '10px' }} onClick={()=>{
              setIsAdOpen(false);
            }}><img src="./x.svg" style={{height:'20px',width:'20px'}}></img>  Close </button>
          </div>
        </Modal>
      }
      {!hideQuote && <div style={{ zIndex: 0, top: '0', left: 0, position: 'absolute', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '95vh', zIndex: '1' }}>
        <p className="typing-demo" style={{ background: 'rgba(0,0,0,0.5)', width: '50%', color: '#fff', height: 'min-content', fontSize: isMobile ? '15px' : '30px', textAlign: 'center', padding: '20px 50px' }}>{quote}</p>
      </div>}
      <div className="block-1" onTouchStart={event=>{enableHover(event.target)}} onMouseEnter={event => { enableHover(event.target) }} onMouseLeave={event => removeHover(event.target)} style={{width: '50%', height: '50%', bottom: '0', background: 'rgba(0, 0, 0, 0)', position: 'absolute', zIndex: '1' }} onClick={() => { setIsOpen(true);
       }}>
        <p  style={{ color: '#fff',fontSize: '48px', padding: '5px 10px', borderRadius: '5px', pointerEvents: 'none'}}>Options</p>
      </div>
      <div className="block-2" onTouchStart={event=>{enableHover(event.target)}}  onMouseEnter={event => { enableHover(event.target) }} onMouseLeave={event => removeHover(event.target)} style={{ width: '50%', height: '50%', bottom: '0', right: '0', background: 'rgba(0,0,0,0)', position: 'fixed', zIndex: '1' }} onClick={() => { getData(); 
        // if (tapCount + 1 >= 5) { setIsAdOpen(true); }else{ setTapCount(tapCount + 1); } 
        }}>
        <p  style={{ color: '#fff',fontSize: '48px', padding: '5px 10px', borderRadius: '5px', pointerEvents: 'none'}}>Next Quote</p>

      </div>
      <div className="block-3" onTouchStart={event=>{enableHover(event.target)}}  onMouseEnter={event => { enableHover(event.target) }} onMouseLeave={event => removeHover(event.target)} style={{ width: '50%', height: '50%', top: '0', right: '0', background: 'rgba(0,0,0,0)', position: 'fixed', zIndex: '1' }} onClick={() => { window.open(image, '_blank'); }}>
                <p  style={{ color: '#fff',fontSize: '48px', padding: '5px 10px', borderRadius: '5px', pointerEvents: 'none'}}>Open Image</p>

      </div>
      <div className="block-4" onTouchStart={event=>{enableHover(event.target)}}  onMouseEnter={event => { enableHover(event.target) }} onMouseLeave={event => removeHover(event.target)} style={{ width: '50%', height: '50%', top: '0', left: '0', background: 'rgba(0,0,0,0)', position: 'fixed', zIndex: '1' }} onClick={() => { navigator.clipboard.writeText(quote); }}>
        <p  style={{ color: '#fff',fontSize: '48px', padding: '5px 10px', borderRadius: '5px', pointerEvents: 'none'}}>Copy Quote</p>

      </div>
    </div>
  </FullScreen>;
}

export default App;
